/**
 * Formatting helpers for Lead Ops UI.
 */
export const formatNumber = (input: number): string => {
  if (!Number.isFinite(input)) return String(input);
  if (Math.abs(input) < 1) return input.toFixed(3);
  return Math.round(input).toLocaleString();
};

export const formatCompact = (n: number): string => {
  if (!Number.isFinite(n) || n < 0) return String(n);
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return String(Math.round(n));
};

export const formatPercent = (input: number): string =>
  `${formatNumber(input)}%`;

export const formatDuration = (seconds: number): string => {
  if (!Number.isFinite(seconds)) return String(seconds);
  const mins = Math.floor(seconds / 60);
  const secs = Math.round(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const formatHumanDate = (value?: string): string => {
  if (!value) return '-';
  const cleaned = value.replace(' UTC', 'Z');
  const parsed = new Date(cleaned);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

export const formatHumanDateTime = (value?: string): string => {
  if (!value) return '';
  const cleaned = value.replace(' UTC', 'Z');
  const parsed = new Date(cleaned);
  if (Number.isNaN(parsed.getTime())) return value;
  const date = parsed.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  const time = parsed.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  return `${date} at ${time}`;
};

export const daysSince = (dateStr?: string | null): number => {
  if (!dateStr) return 0;
  const parsed = new Date(dateStr.replace(' UTC', 'Z'));
  return Math.floor((Date.now() - parsed.getTime()) / 86400000);
};

export const normalizeTitle = (value?: string): string =>
  (value || '')
    .replace(/\*/g, '')
    .replace(/[''']/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
